import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/application';

export const initialState = {
  isApplicationInitialized: false
};

const reducer = (state = initialState, action) => {
  if (action.type === actions.types.ON_INITIALIZE_APPLICATION_FULFILLED) {
    return Object.assign({}, state, {
      isApplicationInitialized: true
    });
  } else if (action.type === actions.types.ON_INITIALIZE_APPLICATION_REJECT) {
    return Object.assign({}, state, {
      isApplicationInitialized: false
    });
  }
  return state;
};

const mapStateToProps = ({ application }) => ({
  application
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onInitializeApplication: actions.onInitializeApplication,
      onInitializeApplicationRejected: actions.onInitializeApplicationRejected,
      onInitializeApplicationFulfilled: actions.onInitializeApplicationFulfilled
    },
    dispatch
  );
const connect = component =>
  reduxConnect(mapStateToProps, mapDispatchToProps)(component);

export default {
  actions,
  connect,
  reducer
};



// WEBPACK FOOTER //
// ./src/reducers/application.js